class NewVetSlider extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      buttons: '.switcher-button',
      descriptions: '.new-vet-approved__description-wrapper',
      descriptionVisible: 'new-vet-approved__description-wrapper--visible',
      images: '.new-vet-approved__image-wrapper',
      imageVisible: 'new-vet-approved__image-wrapper--visible',
      activeBullet: 'switcher-info__bullet--active',
      switcherInfo: '.switcher-info',
      bullets: '.switcher-info__bullet',
      avatars: '.new-vet-approved__vet-avatar',
      activeVet: 'new-vet-approved__vet-avatar--active'
    };

    this.descriptions = this.querySelectorAll(this.selectors.descriptions);
    this.images = this.querySelectorAll(this.selectors.images);
    this.bullets = this.querySelectorAll(this.selectors.bullets);
    this.maxIndex = +this.dataset.maxIndex;
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll(this.selectors.buttons);
    this.avatars = this.querySelectorAll(this.selectors.avatars);
    
    this.switcherInfo = this.querySelector(this.selectors.switcherInfo);
    this.currentIndex = +this.switcherInfo.dataset.current;

    this.buttons.forEach(button => {
      button.addEventListener('click', (event) => this.changeVet(event));
    });

    this.avatars.forEach(avatar => {
      avatar.addEventListener('click', (event) => {
        const index = +event.currentTarget.dataset.vetIndex;
        this.changeActiveIndex(index);
        this.updateActiveVet(index);
      });
    });

    this.updateButtonState(this.currentIndex);
  }

  changeVet(event) {
    const currentButton = event.currentTarget;
    const currentIndex = +this.switcherInfo.dataset.current;

    if (currentButton.classList.contains('button__next')) {
      this.nextIndex = currentIndex + 1;
    } else if (currentButton.classList.contains('button__prev')) {
      this.nextIndex = currentIndex - 1;
    } else {
      return;
    }

    this.changeActiveIndex(this.nextIndex);
    this.updateActiveVet(this.nextIndex);
  }

  changeActiveIndex(num) {
    if (num <= this.maxIndex && num > 0) {
      this.currentIndex = num;
      this.switcherInfo.dataset.current = num;
      this.switcherInfo.innerHTML = `${num}/${this.maxIndex}`;
      this.changeActiveContent(num);
      this.updateButtonState(num);
      this.updateActiveVet(num);
    }
  }

  changeActiveContent(num) {
    this.descriptions.forEach(description => {
      description.classList.remove(this.selectors.descriptionVisible);
    });

    this.images.forEach(image => {
      image.classList.remove(this.selectors.imageVisible);
    });

    this.bullets.forEach(bullet => {
      bullet.classList.remove(this.selectors.activeBullet);
    });

    this.querySelector(`${this.selectors.images}[data-index="${num}"]`)?.classList.add(this.selectors.imageVisible);
    this.querySelector(`${this.selectors.descriptions}[data-index="${num}"]`)?.classList.add(this.selectors.descriptionVisible);
    this.querySelector(`${this.selectors.bullets}[data-active-bullet="${num}"]`)?.classList.add(this.selectors.activeBullet);
  }

  updateActiveVet(num) {
    this.avatars.forEach(avatar => {
      avatar.classList.remove(this.selectors.activeVet);
    });

    const activeAvatar = this.querySelector(
      `${this.selectors.avatars}[data-vet-index="${num}"]`
    );

    activeAvatar?.classList.add(this.selectors.activeVet);
  }

  updateButtonState(currentIndex) {
    const prevBtn = this.querySelector('.button__prev');
    const nextBtn = this.querySelector('.button__next');

    if (prevBtn) prevBtn.disabled = currentIndex <= 1;
    if (nextBtn) nextBtn.disabled = currentIndex >= this.maxIndex;
  }
}

customElements.define('vet-slider', NewVetSlider);
